import React from 'react';
import { secondsToTime } from 'src/lib/time';
import './style.scss';

// TODO: This code was borrowed from an example.
// It could be rewritten in the more common style
// of this app.

// For best results, the height of the gauge is ideally .75 of the width
class EstimateGauge extends React.Component {
  static defaultProps = {
    min: 0,
    max: 8,
    value: 2,
    adjustedEstimate: 4,
    originalEstimate: 2,
    width: 320,
    height: 200,
    color: '#4caf50',
    lesserEstimateColor: '#6ec071',
    greaterEstimateColor: '#80c883',
    backgroundColor: '#ededed',
    valueLabelStyle: {
      textAnchor: 'middle',
      fill: '#444444',
      stroke: 'none',
      fontStyle: 'normal',
      fontVariant: 'normal',
      fontWeight: 'bold',
      fontStretch: 'normal',
      lineHeight: 'normal',
      fillOpacity: 1
    },
    minMaxLabelStyle: {
      textAnchor: 'middle',
      fill: '#999999',
      stroke: 'none',
      fontStyle: 'normal',
      fontVariant: 'normal',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontSize: 20,
      lineHeight: 'normal',
      fillOpacity: 1
    }
  };

  componentWillMount = () => {
    // In order to have multiple gauges rendered at once, each needs its
    // own filter ID for css/browser to handle it properly
    this.filter_id = Math.random();
  };

  _getPathValues = (value) => {
    var dx = 0;
    // var dy = 0;
    // var gws = 1;

    var Cx = this.props.width / 2 + dx; // Center
    //var Cy = (this.props.height / 2) + 60

    //var Cy = (this.props.height / 2) + (this.props.height / 8) + (this.props.minMaxLabelStyle.fontSize + 10) + dy;

    // Works nicely as long as height = width * .75
    //var Cy = (this.props.width / 2) + (this.props.width / 8) - (this.props.minMaxLabelStyle.fontSize - 7.5) + dy;

    var textHeight = this.props.minMaxLabelStyle.fontSize - 10;
    var height = this.props.height;
    var width = this.props.width;
    var diff = height / width;
    var offset = (height / 4) * diff - textHeight / diff;
    var Cy = this.props.width / 2 + offset;

    var alpha =
      (1 - (value - this.props.min) / (this.props.max - this.props.min)) *
      Math.PI;
    var Ro = Cx; //this.props.width / 2 - this.props.width / 10;
    var Ri = Ro - this.props.width / 5; // 6.666666666666667;

    var Xo = this.props.width / 2 + dx + Ro * Math.cos(alpha);
    var Yo =
      this.props.height - (this.props.height - Cy) - Ro * Math.sin(alpha);
    var Xi = this.props.width / 2 + dx + Ri * Math.cos(alpha);
    var Yi =
      this.props.height - (this.props.height - Cy) - Ri * Math.sin(alpha);

    return { alpha, Ro, Ri, Cx, Cy, Xo, Yo, Xi, Yi };
  };

  _getPath = (value) => {
    // var dx = 0;
    // var dy = 0;
    // var gws = 1;

    var { Ro, Ri, Cx, Cy, Xo, Yo, Xi, Yi } = this._getPathValues(value);

    var path = 'M' + (Cx - Ri) + ',' + Cy + ' ';
    path += 'L' + (Cx - Ro) + ',' + Cy + ' ';
    path += 'A' + Ro + ',' + Ro + ' 0 0 1 ' + Xo + ',' + Yo + ' ';
    path += 'L' + Xi + ',' + Yi + ' ';
    path += 'A' + Ri + ',' + Ri + ' 0 0 0 ' + (Cx - Ri) + ',' + Cy + ' ';
    path += 'Z ';

    return path;
  };

  render() {
    var valueLabelStyle = this.props.valueLabelStyle.fontSize
      ? this.props.valueLabelStyle
      : { ...this.props.valueLabelStyle, fontSize: this.props.width / 7 };
    // var { Cx, Ro, Ri, Xo, Cy, Xi } = this._getPathValues(this.props.max);
    var { Xo, Cy, Xi } = this._getPathValues(this.props.max);
    // If value is above max, render max path but value text. Else the value path is distorted
    var maxPath = this._getPath(this.props.max);
    var value = this._getPathValues(this.props.value);
    var valuePath = this._getPath(this.props.value);
    valuePath = value.alpha >= 0 ? valuePath : maxPath;
    var lesserEstimate = Math.min(
      this.props.adjustedEstimate,
      this.props.originalEstimate
    );
    var lesserEstimateVal = this._getPathValues(lesserEstimate);
    var lesserEstimatePath = this._getPath(lesserEstimate);
    lesserEstimatePath =
      lesserEstimateVal.alpha >= 0 ? lesserEstimatePath : maxPath;
    var greaterEstimate = Math.max(
      this.props.adjustedEstimate,
      this.props.originalEstimate
    );
    var greaterEstimateVal = this._getPathValues(greaterEstimate);
    var greaterEstimatePath = this._getPath(greaterEstimate);
    greaterEstimatePath =
      greaterEstimateVal.alpha >= 0 ? greaterEstimatePath : maxPath;
    return (
      <div className="estimate-gauge">
        <svg
          height="100%"
          version="1.1"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: this.props.width,
            height: this.props.height,
            overflow: 'hidden',
            position: 'relative',
            left: 0,
            top: 0
          }}
        >
          <defs>
            <filter id={this.filter_id}>
              <feOffset dx="0" dy="3" />
              <feGaussianBlur result="offset-blur" stdDeviation="5" />
              <feComposite
                operator="out"
                in="SourceGraphic"
                in2="offset-blur"
                result="inverse"
              />
              <feFlood floodColor="black" floodOpacity="0.2" result="color" />
              <feComposite
                operator="in"
                in="color"
                in2="inverse"
                result="shadow"
              />
              <feComposite operator="over" in="shadow" in2="SourceGraphic" />
            </filter>
          </defs>
          <path
            fill={this.props.backgroundColor}
            stroke="none"
            d={maxPath}
            filter={`url(#${this.filter_id})`}
          />
          <path
            fill={this.props.greaterEstimateColor}
            stroke="none"
            d={greaterEstimatePath}
          />
          <path
            fill={this.props.lesserEstimateColor}
            stroke="none"
            d={lesserEstimatePath}
          />
          <path
            fill={this.props.color}
            stroke="none"
            d={valuePath}
            filter={`url(#${this.filter_id})`}
            className="time-passed"
          />
          {this.props.label && (
            <text
              x={this.props.width / 2}
              y={Cy}
              textAnchor="middle"
              style={valueLabelStyle}
            >
              {this.props.label}
            </text>
          )}
          {/* <text
            x={(Cx - Ro + (Cx - Ri)) / 2}
            y={Cy + this.props.minMaxLabelStyle.fontSize}
            textAnchor="middle"
            style={this.props.minMaxLabelStyle}
          >
            {this.props.min}
          </text> */}
          <text
            x={(Xo + Xi) / 2}
            y={Cy + this.props.minMaxLabelStyle.fontSize}
            textAnchor="middle"
            style={this.props.minMaxLabelStyle}
          >
            {secondsToTime(this.props.max)}
          </text>
        </svg>
      </div>
    );
  }
}

export default EstimateGauge;
